module.exports = __webpack_public_path__ + "img/como-funciona-2.7d515483.jpg";